// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".fa5376c169d844d803d55279aea423e63416c423.chunk.js";
};